module.exports = __webpack_public_path__ + "img/ic_file-page-missing.2f866759.svg";